module.exports = __webpack_public_path__ + "img/charity.54a3662e.svg";